import { ActionType } from "../store/ChatAction";
import { log } from "../utils";
import { ChatServer, OfflineMessage, VisitorInfoMessage } from "./ChatServer";
import { ChatMessageRequest, ChatServerMessage } from "./ChatServerMessage";

export class LogChat implements ChatServer {

    private readonly inner: ChatServer;

    constructor(inner: ChatServer) {
        this.inner = inner;
    }

    public bargeOut(cb: (err?: Error) => void): void {
        log(`CLIENT: bargeOut`);
        this.inner.bargeOut(cb);
    }

    public bargeIn(agentName: string, cb: (err?: Error) => void): void {
        log(`CLIENT: bargeIn: ${agentName}`);
        this.inner.bargeIn(agentName, cb);
    }

    public init(dispatch: (action: ActionType) => void): void {
        this.inner.init(dispatch);
    }

    public sendOfflineMsg(message: OfflineMessage, cb: (error?: Error) => void): void {
        log(`CLIENT: sendOfflineMsg: ${JSON.stringify(message)}`);
        this.inner.sendOfflineMsg(message, cb);
    }

    public sendChatMsg(message: ChatServerMessage, cb: (err?: Error) => void): void {
        log(`CLIENT: sendChatMsg: ${JSON.stringify(message)}`);
        this.inner.sendChatMsg(message, cb);
    }

    public sendChatMsgRequest(message: ChatMessageRequest, cb: (err?: Error) => void): void {
        log(`CLIENT: sendChatMsgRequest: ${JSON.stringify(message)}`);
        this.inner.sendChatMsgRequest(message, cb);
    }

    public sendTyping(isTyping: boolean): void {
        log(`CLIENT: sendTyping: ${JSON.stringify(isTyping)}`);
        this.inner.sendTyping(isTyping);
    }

    public setVisitorInfo(visitorInfo: VisitorInfoMessage, sessionId: string, cb: (error?: Error) => void): void {
        log(`CLIENT: setVisitorInfo: ${JSON.stringify(visitorInfo)} session id: ${sessionId}`);
        this.inner.setVisitorInfo(visitorInfo, sessionId, cb);
    }

    public sendChatRating(rating?: "bad" | "good"): void {
        log(`CLIENT: sendChatRating: ${JSON.stringify(rating)}`);
        this.inner.sendChatRating(rating);
    }

    public sendFile(file: File, cb: (err?: Error) => void): void {
        log(`CLIENT: sendFile: ${JSON.stringify(file)}`);
        this.inner.sendFile(file, cb);
    }

    public markAsRead(): void {
        log(`CLIENT: markAsRead:`);
        this.inner.markAsRead();
    }

    public flush(): void {
        log(`CLIENT: flush:`);
        this.inner.flush();
    }

    public dispose(): void {
        log(`CLIENT: dispose:`);
        this.inner.dispose();
    }

    public sleep(): void {
        log(`CLIENT: sleep:`);
        this.inner.sleep();
    }

    public wakeup(): void {
        log(`CLIENT: wakeup:`);
        this.inner.wakeup();
    }
}